module.exports = __webpack_public_path__ + "static/media/menu2.a735492f.jpeg";